import { gql } from "@apollo/client";

export const GET_DISK_ANALYSIS = gql`
  query GetDiskAnalysis($vmId: ID!) {
    getDiskAnalysis(vmId: $vmId) {
      id
      vmId
      vmName
      daysUntilFull
      riskLevel
      predictionRecommendation
      anomalyDetected
      anomalyDetails
      anomalyPossibleCauses
      optimizationSuggestion
      optimizationAction
      createdAt
    }
  }
`;

export const ANALYZE_ALL_VMS_DISKS = gql`
  mutation AnalyzeAllVmsDisks {
    analyzeAllVmsDisks
  }
`;